"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("../resources/prism-theme.css");
function CodeBlock(_a) {
  var children = _a.children,
    className = _a.className,
    _b = _a.size,
    size = _b === void 0 ? 'base' : _b;
  var _c;
  var style = {
    backgroundColor: '#eee'
  };
  if (size === 'sm') {
    style.padding = '1rem';
  }
  // Ensure a language type is always present
  var extendedClassName = className;
  if (!((_c = className) === null || _c === void 0 ? void 0 : _c.includes('language-'))) {
    extendedClassName = classnames_1.default(className, 'language-text');
  }
  return React.createElement("div", {
    className: "mb-8"
  }, React.createElement("pre", {
    className: classnames_1.default(extendedClassName, 'rounded-lg shadow-lg'),
    style: style
  }, children));
}
exports.CodeBlock = CodeBlock;